import { useState } from "react";
import { useDispatch } from "react-redux";
import { subDays } from "date-fns";
import { updateConfig } from "../../../store/slices/Delivery/invoicesSlice";

// Shared search / date / sort / pagination handlers for an invoices tab.
// `targetKey` is the slice key whose query state is being mutated
// ("pendingTab" or "completedTab").
const useTabFilters = (targetKey) => {
  const dispatch = useDispatch();

  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const [formattedDate, setFormattedDate] = useState([startDate, endDate]);

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state[targetKey].currentPageSize = page_size;
        state[targetKey].currentPage = 1;
      }),
    );
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state[targetKey].currentPage = page;
      }),
    );
  };

  const handleSort = (label) => {
    dispatch(
      updateConfig((state) => {
        if (state[targetKey].sortBy === label) {
          state[targetKey].sortOrder =
            state[targetKey].sortOrder === "asc" ? "desc" : "asc";
        } else {
          state[targetKey].sortBy = label;
          state[targetKey].sortOrder = "asc";
        }
        state[targetKey].currentPage = 1;
      }),
    );
  };

  const handleSearch = (e) => {
    const value = e?.target?.value ?? "";
    dispatch(
      updateConfig((state) => {
        state[targetKey].search = value;
        state[targetKey].currentPage = 1;
      }),
    );
  };

  const handleDateChange = (range) => {
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startIST = new Date(
      new Date(range.startDate).getTime() + timeZoneOffset,
    );
    const endIST = new Date(new Date(range.endDate).getTime() + timeZoneOffset);
    const formatDate = (d) =>
      `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(
        2,
        "0",
      )}-${String(d.getUTCDate()).padStart(2, "0")}`;
    setDate(range);
    setFormattedDate([formatDate(startIST), formatDate(endIST)]);
    dispatch(
      updateConfig((state) => {
        state[targetKey].currentPage = 1;
      }),
    );
  };

  return {
    date,
    formattedDate,
    handlePageSize,
    handlePagination,
    handleSort,
    handleSearch,
    handleDateChange,
  };
};

export default useTabFilters;
